// Mirror of App\Enums\NominationList (campdraftone-api)
export const NOMINATION_LIST_UNPROCESSED = 'unprocessed'
export const NOMINATION_LIST_ACCEPT = 'accept'
export const NOMINATION_LIST_WAITLIST = 'waitlist'



// WEBPACK FOOTER //
// ./src/constants/nominationLists.js